export enum AppEventName {
  //APP EVENTS
  APP_START = 'APP_START',
  APP_FOREGROUND = 'APP_FOREGROUND',
  APP_BACKGROUND = 'APP_BACKGROUND',
  SEARCH = 'SEARCH',
  SUBSCRIPTION_INITIATED = 'SUBSCRIPTION_INITIATED',
  PAYMENT_INITIATED = 'PAYMENT_INITIATED',
  VIEW_CONTENT_DETAILS = 'VIEW_CONTENT_DETAILS',
  RENT_CONTENT = 'RENT_CONTENT',
  APP_UPDATE = 'APP_UPDATE',
  FAVORITE_CONTENT = 'FAVORITE_CONTENT',
  STOREFRONT_TAB_CHANGE = 'STOREFRONT_TAB_CHANGE',
  MENU_TAB_CHANGE = 'MENU_TAB_CHANGE',
  VIEW_COLLECTION_DETAILS = 'VIEW_COLLECTION_DETAILS',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  VIEW_PLANS = 'VIEW_PLANS',
  NETWORK_CHANGE = 'NETWORK_CHANGE',
  IN_APP_BANNER_CLICK = 'IN_APP_BANNER_CLICK',
  SET_PREFERRED_LANGUAGE = 'SET_PREFERRED_LANGUAGE',
  ERROR = 'APP_ERROR',
}

export enum PlaybackEventName {
  // PLAYBACK EVENTS
  PLAYBACK_START = 'PLAYBACK_START',
  PLAYBACK_PREPARED = 'PLAYBACK_PREPARED',
  PLAYBACK_STARTED = 'PLAYBACK_STARTED',
  PLAYBACK_INPROGRESS = 'PLAYBACK_INPROGRESS',
  PLAYBACK_BUFFERING_START = 'PLAYBACK_BUFFERING_START',
  PLAYBACK_BUFFERING_END = 'PLAYBACK_BUFFERING_END',
  PLAYBACK_SEEK_START = 'PLAYBACK_SEEK_START',
  PLAYBACK_SEEK_COMPLETE = 'PLAYBACK_SEEK_COMPLETE',
  PLAYBACK_PAUSED = 'PLAYBACK_PAUSED',
  PLAYBACK_RESUMED = 'PLAYBACK_RESUMED',
  PLAYBACK_STOPPED = 'PLAYBACK_STOPPED',
  PLAYBACK_COMPLETE = 'PLAYBACK_COMPLETE',
  PLAYBACK_VARIANT_CHANGE = 'PLAYBACK_VARIANT_CHANGE',
  PLAYBACK_AUDIO_LANGUAGE_CHANGE = 'PLAYBACK_AUDIO_LANGUAGE_CHANGE',
  PLAYBACK_SUBTITLE_LANGUAGE_CHANGE = 'PLAYBACK_SUBTITLE_LANGUAGE_CHANGE',
  NETWORK_CHANGE = 'NETWORK_CHANGE',
  ERROR = 'ERROR',
  AD_BREAK_START = 'AD_BREAK_START',
  AD_START = 'AD_START',
  AD_END = 'AD_END',
  AD_BREAK_COMPLETE = 'AD_BREAK_COMPLETE',
  AD_VIEW = 'AD_VIEW',
  AD_SKIP = 'AD_SKIP',
  AD_PLAYBACK_ERROR = 'AD_PLAYBACK_ERROR',
}

export type EventName = AppEventName | PlaybackEventName;
